module.exports = {"apiUrl":" https://frozen-retreat-24077.herokuapp.com/api"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 7
// module chunks = 0